import { useEffect, useState } from 'react';

import gql from 'graphql-tag';

import getGqlClient from '../client';

const QUERY_AREAS = gql`
  query Areas($city: String!) {
    areas(city: $city) {
      id
      name
    }
  }
`;

export const getAreasQuery = client => city =>
  client.query({
    query: QUERY_AREAS,
    fetchPolicy: 'cache-first',
    variables: {
      city
    }
  });

const QUERY_AREA_INFO = gql`
  query AreaInfo($city: String!, $slug: String!) {
    areaInfo(city: $city, slug: $slug) {
      id
      name
      slug
    }
  }
`;

export const getAreaInfoQuery = client => (city, slug) =>
  client.query({
    query: QUERY_AREA_INFO,
    fetchPolicy: 'cache-first',
    variables: {
      city,
      slug
    }
  });

export const useAreas = cityId => {
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    const getAreas = async city => {
      try {
        const { data } = await getAreasQuery(getGqlClient())(city);
        setAreas(data.areas);
      } catch (e) {
        console.log('Something went wrong fetching areas, ', e);
      }
    };

    getAreas(cityId);
  }, [cityId]);

  return areas;
};

export default { getAreasQuery, getAreaInfoQuery, useAreas };
